export enum RedirectReasonCode {
    REFRESH_TIMEOUT = 'EXPIRADO_REFRESCO',
    REFRESH_ERROR = 'ERROR_DE_REFRESCO',
    UNEXPECTED_REASON = 'ERROR_INESPERADO',
    MANUAL = 'MANUAL',
    EXAMINATION_END = 'EXAMEN_FINALIZADO',
    EXAMINATION_CANCELLED = 'EXAMEN_CANCELADO'
}

export interface QueryMapConfig {
    title?: string;
    message?: string;
    showError: boolean;
}

export const REDIRECT_REASON_MAP: Record<RedirectReasonCode, QueryMapConfig> = {
    [RedirectReasonCode.REFRESH_TIMEOUT]: {
        title: 'Sesión expirada',
        message: 'Su sesión ha expirado. Por favor, vuelva a iniciar sesión.',
        showError: true
    },
    [RedirectReasonCode.REFRESH_ERROR]: {
        title: 'Ocurrio un error con su sesion',
        message: 'Ha ocurrido un error al momento de verificar su sesión; por su seguridad, la sesión fue terminada. Por favor, vuelva a iniciar sesión.',
        showError: true
    },
    [RedirectReasonCode.UNEXPECTED_REASON]: {
        title: 'Redirección inesperada',
        message: 'Ha sido redirigido a la página de login debido a un motivo desconocido.  Por favor, vuelva a iniciar sesión.',
        showError: true
    },
    [RedirectReasonCode.MANUAL]: {
        showError: false
    },
    [RedirectReasonCode.EXAMINATION_END]: {
        showError: false
    },
    [RedirectReasonCode.EXAMINATION_CANCELLED]: {
        showError: false
    },
}